import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import ListItem from '@material-ui/core/ListItem';
import List from '@material-ui/core/List';
import React from 'react';
import {connect} from 'react-redux';
import {I18n} from 'react-redux-i18n';
import Select from '../../../components/Select';
import MultipleSelectFilter from '../../../LibraryFilter/component/MultipleSelectFilter';
import {
  setCardView,
  setGroups,
  loadGroups,
  loadHealthStatus,
  setHealthStatus,
  clearHidableFilters
} from '../HealthFiltersActions';

class HidableFilters extends React.Component {
  constructor(props) {
    super(props);
    const {applied} = props;
    const {groups, status, cardView} = applied;
    this.state = {groups, status, cardView};
  }

  componentDidMount() {
    this.props.loadGroups();
    this.props.loadHealthStatus();
  }

  handleGroupSelection = value => {
    this.setState({groups: value});
  }

  handleHealthStatusSelection = value => {
    this.setState({status: value});
  }

  handleOnClear = () => {
    this.setState({groups: [], status: [], cardView: 'standard'}, this.props.clearHidableFilters);
    this.props.onClose();
  }

  handleClose = () => {
    const {applied} = this.props;
    this.setState({...applied}, this.props.onClose);
  }

  handleOnApply = () => {
    this.props.setGroups(this.state.groups);
    this.props.setHealthStatus(this.state.status);
    this.props.setCardView(this.state.cardView);
    this.props.onClose();
  }

  handleCardView = value => {
    this.setState({cardView: value});
  }

  render() {
    return (
      <Dialog
        open={this.props.open}
        onClose={this.handleClose}
        BackdropProps={{
          invisible: true
        }}
        classes={{
          root: 'libraryfilter',
          paper: 'libraryfilter__paper'
        }}
      >
        <List className="librarylist desktopfilters__list">
          <ListItem>
            <MultipleSelectFilter
              options={this.props.groups.entries}
              label={I18n.t('filter.group.label')}
              value={this.state.groups}
              onChange={this.handleGroupSelection}
              isMobile={false}
              id="filterGroup"
            />
          </ListItem>
          <ListItem>
            <Select
              name="healthStatus"
              options={this.props.status.entries}
              label={I18n.t('filter.healthStatus.label')}
              translationPrefix="filter.healthStatus.option"
              value={this.state.status}
              onChange={this.handleHealthStatusSelection}
              id="filterHealth"
            />
          </ListItem>
          <ListItem>
            <Select
              label={I18n.t('page.dvrHealth.cardType.label')}
              name="cardView"
              onChange={this.handleCardView}
              value={this.state.cardView}
              options={[
                {id: 'standard', label: I18n.t('page.dvrHealth.cardType.standard')},
                {id: 'snapshot', label: I18n.t('page.dvrHealth.cardType.snapshot')}
              ]}
            />
          </ListItem>
          <ListItem className="desktopfilters__actions">
            <Button variant="contained" onClick={this.handleOnClear} id="filterClear" className="btn btn-secondary">{I18n.t('action.clear')}</Button>
            <Button variant="contained" onClick={this.handleOnApply} color="primary" className="btn btn-primary" id="filterApply">
              {I18n.t('action.apply')}
            </Button>
          </ListItem>
        </List>
      </Dialog>
    );
  }
}

const mapStateToProps = state => ({...state.i18n.locale, ...state.dvrFilter});
export default connect(mapStateToProps, {
  setCardView,
  setGroups,
  loadGroups,
  loadHealthStatus,
  clearHidableFilters,
  setHealthStatus
})(HidableFilters);
